import Filter from './filter';
import isValidFileType from '../helpers/is-valid-file-type';
import type UploaderFile from '../uploader-file';
import Uploader from '../uploader';
import UploaderError from '../uploader-error';

export default class FileTypeFilter extends Filter
{
	constructor(uploader: Uploader, filterOptions: { [key: string]: any } = {})
	{
		super(uploader);
	}

	apply(file: UploaderFile): Promise
	{
		return new Promise((resolve, reject) => {

			if (isValidFileType(file.getFile(), this.getUploader().getAcceptedFileTypes()))
			{
				resolve();
			}
			else
			{
				reject(new UploaderError('FILE_TYPE_NOT_ALLOWED'));
			}
		});
	}
}